<div class="d-flex w-100 align-items-center">

  @if (tender.assignees && tender.assignees.length) {
    <app-overflow-list
      [items]="items">

      <ng-template #itemTemplate let-item>
        <app-searchable-entity
          class="pdh-4px"
          [attributeName]="'organisation'"
          [baseUrl]="environment.appBaseUrl + '/tenders/search'"
          [entityName]="item.label"/>
      </ng-template>

      <ng-template #moreButtonTemplate let-count="count">
        <span class="action-button no-select {{styleClass}}"
              cdkOverlayOrigin #trigger="cdkOverlayOrigin"
              (click)="$event.stopPropagation(); toggle(tender.id)"
              [ngbTooltip]="(tender.id !== tenderId ? 'tenders.tooltips.click-to-see' : '') | translate"
              [openDelay]="500"
              tooltipClass="simple-tooltip"
              placement="top auto"
              container="body">
          {{ '+ ' + count }}
        </span>

        <!--Content of overlay displayed when clicked-->
        <ng-template cdkConnectedOverlay
                     [cdkConnectedOverlayOrigin]="trigger"
                     [cdkConnectedOverlayOpen]="tender.id === tenderId"
                     [cdkConnectedOverlayPositions]="positions"
                     (overlayOutsideClick)="close()"
                     disableScrollContainer
        >
          <div class="popover-container d-flex flex-column gap-1">
            <div
              class="popover-title">{{ 'tenders.other-assignee' + (tender.assignees.length > 1 ? 's' : '') | translate }}
            </div>
            <div class="d-flex flex-column gap-1 assignees-list">
              @for (assignee of tender.assignees; track assignee) {
                <ng-container *ngTemplateOutlet="assigneeItem; context: { $implicit: assignee }"/>
              }
            </div>
          </div>
        </ng-template>

      </ng-template>

    </app-overflow-list>
  }

  <!--Attributaire cliquable-->
  <ng-template #assigneeItem let-assignee>
    <!--La directive clickBlocked Sera retirée pour le lot 2-->
    <app-searchable-entity
      class="pdh-4px"
      [styleClass]="'darkblue'"
      [attributeName]="'organisation'"
      [baseUrl]="environment.appBaseUrl + '/tenders/search'"
      [entityName]="assignee"/>
  </ng-template>
</div>
